'use strict';

angular.module('accessModule')

  .run(function ($rootScope, $state, kdGate, Auth) {
    const hidden = [
      'admin.basket.edit',
      'admin.basket.delete',
      'admin.basket.move',
      'admin.basket.editFolder',
      'admin.broadcasters.edit',
      'admin.broadcasters.delete',
      'admin.broadcasters.move',
      'admin.broadcasters.upload',
      'admin.broadcasters.editFolder',
      'admin.broadcasters.edit-folder-thumb'
    ];

    const blackList = {
      'admin.users': ['user-management.users', 'role-management'],
      'admin.access-requests': ['user-management.users', 'role-management'],
      'admin.roles': ['user-management.roles'],
      'admin.actions': ['user-management.actions'],
      'admin.media.edit': ['library.edit'],
      'admin.media.delete': ['library.edit'],
      'admin.media.move': ['library.edit'],
      'admin.media.upload': ['library.edit'],
      'admin.media.editFolder': ['library.edit'],
      'admin.media.edit-folder-thumb': ['library.edit'],
      'admin.broadcasters.edit': ['broadcasters.edit'],
      'admin.broadcasters.delete': ['broadcasters.edit'],
      'admin.broadcasters.move': ['broadcasters.edit'],
      'admin.broadcasters.upload': ['broadcasters.edit'],
      'admin.broadcasters.editFolder': ['broadcasters.edit'],
      'admin.broadcasters.edit-folder-thumb': ['broadcasters.edit'],
    };

    const whiteList = [
      'guest.forgot-password',
      'guest.forgot-password-success',
      'guest.reset-password',
      'guest.reset-password-success',
      'guest.access-request',
    ];

    $rootScope.$on('$stateChangeStart', stateChangeAccessCheck);

    function stateChangeAccessCheck(event, toState, $window) {
      // remove this if you need broadcasters routes
      if(toState.name.includes('broadcasters') || toState.name.includes('access-request')) {
        redirect(event);
      }

      if (hidden.indexOf(toState.name) > -1) {
        redirect(event);
      }

      if (whiteList.indexOf(toState.name) > -1) {
        return;
      }

      Auth.allowedAccess();

      if (!blackList[toState.name]) {
        return;
      }

      let blackListGates = blackList[toState.name];

      let allowed = blackListGates.reduce((result, value) => {
        return result || kdGate.allows(value);
      }, false);

      if (allowed) {
        return;
      }

      redirect(event);
    }

    function redirect(event) {
      event.preventDefault();
      //$state.go('admin.welcome', {}, {location: "replace"});
      $state.go('admin.media', {}, {location: "replace"});
    }
  });
